<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.contracts.contragent") }}
              </h4>
            </div>
            <div class="card-body px-3">
              <div class="row" v-if="show == 0">
                <div class="col-md-6">
                  <div
                    class="card"
                    style="cursor: pointer"
                    @click="show_user()"
                  >
                    <div class="card-body">
                      <div class="d-flex">
                        <div
                          class="img-thumbnail mr-3 rounded-circle"
                          style="
                            max-width: 100%;
                            width: 100px;
                            position: relative;
                            height: 100px;
                            overflow: hidden;
                            flex-shrink: 0;
                          "
                        >
                          <img
                            :src="person.avatar"
                            style="
                              max-width: 100px;
                              position: absolute;
                              left: 0;
                              top: 0;
                            "
                          />
                        </div>

                        <div>
                          <div class="h5 font-weight-bold mb-0">
                            {{ $t("message.account.user-section") }}
                          </div>
                          <div
                            class="h5 font-weight-normal text-truncate"
                            style=""
                          >
                            {{ person.given_name }} {{ person.last_name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="card"
                    style="cursor: pointer"
                    @click="show_company()"
                  >
                    <div class="card-body">
                      <div
                        class="d-flex align-content-center align-items-center"
                      >
                        <div
                          class="img-thumbnail mr-3 rounded-circle"
                          style="
                            max-width: 100%;
                            width: 100px;
                            position: relative;
                            height: 100px;
                            overflow: hidden;
                            flex-shrink: 0;
                          "
                        >
                          <img
                            :src="organization.logo"
                            style="
                              max-width: 100px;
                              position: absolute;
                              left: 0;
                              top: 0;
                            "
                          />
                        </div>
                        <div>
                          <div class="h5 font-weight-bold mb-0">
                            {{ $t("message.account.company-section") }}
                          </div>
                          <div
                            class="h5 font-weight-normal text-truncate"
                            style=""
                          >
                            {{ organization.org_name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="show == 1">
                <!--user-->
                <div class="col-12">
                  <button class="btn btn-sm btn-link" @click="show = 0">
                    <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
                  </button>
                </div>
                <div class="col-md-4 bg-light rounded text-center p-3">
                  <avatar
                    :url="url"
                    :image="person.avatar"
                    type="avatar"
                  ></avatar>
                  <h4>{{ person.given_name }} {{ person.last_name }}</h4>
                  <!--<router-link :to="{name: 'my-offers'}" class="btn btn-link w-100 d-block">{{$t('message.account.offers')}}</router-link>-->
                </div>
                <div class="col-md-8">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="person_code">{{
                        $t("message.account.iin")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.person_code }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="person_code"
                        v-model="person.person_code"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="position">{{
                        $t("message.account.position")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.position }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="position"
                        v-model="person.position"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="date_of_birth">{{
                        $t("message.account.dob")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        person.date_of_birth
                      }}</span>
                      <datepicker
                        v-else
                        @focus="person.date_of_birth = ' '"
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @blur="
                          person.date_of_birth == ' '
                            ? (person.date_of_birth = '')
                            : (person.date_of_birth = person.date_of_birth)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="person.date_of_birth"
                        :placeholder="$t('message.account.customer_birthdate')"
                        :inputAttr="{ id: 'customer_birthdate' }"
                      />
                      <!-- <b-form-datepicker :locale="locale" v-model="person.date_of_birth" :placeholder="$t('message.account.dob')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="date_of_birth" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="address">{{
                        $t("message.account.address")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.post_address }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        v-model="person.post_address"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="email">{{
                        $t("message.account.email")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{ person.person_email }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        v-model="person.person_email"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.gender") }}</span
                      ><br /><br />
                      <input
                        type="checkbox"
                        v-model="person.gender"
                        :disabled="!edit_person"
                      />
                      <span class="toggle"></span>
                      <span class="female">{{
                        $t("message.reg_form.customer_female")
                      }}</span>
                      <span class="male">{{
                        $t("message.reg_form.customer_male")
                      }}</span>
                    </label>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="phone">{{
                        $t("message.account.phone")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        person.person_phone_number
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        v-model="person.person_phone_number"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="residency">{{
                        $t("message.account.residency")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_person">{{
                        person.country.display_text
                      }}</span>
                      <!-- <v-select id="residency" :options="countries" label="display_text" :class="['form-control', typeof person.country !== 'undefined' && person.country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="person.country" v-else></v-select> -->
                      <v-select-popup
                        v-else
                        type="country"
                        v-model="person.country"
                        :placeholder="$t('message.account.residency')"
                      />
                    </div>
                  </div>
                  <div class="row my-2" v-if="edit_person">
                    <div class="col-12">
                      <button class="btn btn-success" @click="savePerson()">
                        {{ $t("message.save") }}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a
                        v-show="!empty(socials_person.skype)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="'skype:' + socials_person.skype"
                        ><i class="text-info fab fa-skype fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials_person.linkedin)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials_person.linkedin"
                        ><i class="text-info fab fa-linkedin fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials_person.fb)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials_person.fb"
                        ><i class="text-info fab fa-facebook fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials_person.instagram)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials_person.instagram"
                        ><i class="text-info fab fa-instagram fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials_person.vk)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials_person.vk"
                        ><i class="text-info fab fa-vk fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials_person.wechat)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="'weixin://dl/chat?' + socials_person.wechat"
                        ><i class="text-info fab fa-weixin fa-2x"></i
                      ></a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div
                        id="person_map"
                        :class="[
                          'mt-3',
                          'rounded',
                          loading_map ? 'loading-map' : '',
                        ]"
                        style="height: 300px"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="show == 2">
                <!--company-->
                <div class="col-12">
                  <button class="btn btn-sm btn-link" @click="show = 0">
                    <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
                  </button>
                </div>
                <div class="col-md-4 bg-light rounded text-center p-3">
                  <avatar
                    :url="url_company"
                    :image="organization.logo"
                    type="logo"
                  ></avatar>
                  <h4>{{ organization.org_name }}</h4>
                </div>
                <div class="col-md-8">
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_name">{{
                        $t("message.account.org_name")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_name
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="org_name"
                        v-model="organization.org_name"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_code">{{
                        $t("message.account.bin")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_code
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="company_code"
                        v-model="organization.org_code"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_custom_code">{{
                        $t("message.account.org_custom_code")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_custom_code
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="org_custom_code"
                        v-model="organization.org_custom_code"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_oked">{{
                        $t("message.account.org_oked")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_oked.display_text
                      }}</span>
                      <!-- <v-select id="org_oked" :options="okeds" label="display_text" :class="['form-control', typeof organization.org_oked !== 'undefined' && organization.org_oked.value!==''?'vs--selected':'']" @search=fetchOkeds v-model="organization.org_oked" v-else></v-select> -->

                      <v-select-popup
                        v-else
                        type="oked"
                        v-model="organization.org_oked"
                        :placeholder="$t('message.account.org_oked')"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_type">{{
                        $t("message.account.org_type")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_type.display_text
                      }}</span>
                      <!-- <v-select id="org_type" :options="org_types" label="display_text" :class="['form-control', typeof organization.org_type !== 'undefined' && organization.org_type.value!==''?'vs--selected':'']" @search=fetchOrgTypes v-model="organization.org_type" v-else></v-select> -->
                      <v-select-popup
                        v-else
                        type="org_type"
                        v-model="organization.org_type"
                        :placeholder="$t('message.account.org_type')"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_contacts">{{
                        $t("message.account.company_contacts")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_contacts
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="company_contacts"
                        v-model="organization.company_contacts"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_reg_date">{{
                        $t("message.account.org_reg_date")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_reg_date
                      }}</span>
                      <datepicker
                        v-else
                        @focus="organization.org_reg_date = ' '"
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @blur="
                          organization.org_reg_date == ' '
                            ? (organization.org_reg_date = '')
                            : (organization.org_reg_date =
                                organization.org_reg_date)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="organization.org_reg_date"
                        :placeholder="$t('message.account.org_reg_date')"
                        :inputAttr="{ id: 'org_reg_date' }"
                      />
                      <!-- <b-form-datepicker :locale="locale" v-model="organization.org_reg_date" :placeholder="$t('message.account.org_reg_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="org_reg_date" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="org_reregdate">{{
                        $t("message.account.org_reregdate")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.org_reregdate
                      }}</span>
                      <datepicker
                        v-else
                        @focus="organization.org_reregdate = ' '"
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @blur="
                          organization.org_reregdate == ' '
                            ? (organization.org_reregdate = '')
                            : (organization.org_reregdate =
                                organization.org_reregdate)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="organization.org_reregdate"
                        :placeholder="$t('message.account.org_reregdate')"
                        :inputAttr="{ id: 'org_reregdate' }"
                      />
                      <!-- <b-form-datepicker :locale="locale" v-model="organization.org_reregdate" :placeholder="$t('message.account.org_reg_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="org_reregdate" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_status">{{
                        $t("message.account.company_status")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_status.display_text
                      }}</span>
                      <!-- <v-select id="company_status" :options="statuses" label="display_text" :class="['form-control', typeof organization.company_status !== 'undefined' && organization.company_status.value!==''?'vs--selected':'']" @search=fetchStatuses v-model="organization.company_status" v-else></v-select> -->
                      <v-select-popup
                        v-else
                        type="status"
                        v-model="organization.company_status"
                        :placeholder="$t('message.account.residency')"
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_ceo">{{
                        $t("message.account.company_ceo")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_ceo
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="company_ceo"
                        v-model="organization.company_ceo"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_ceo_date">{{
                        $t("message.account.company_ceo_date")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_ceo_date
                      }}</span>
                      <datepicker
                        v-else
                        @focus="organization.company_ceo_date = ' '"
                        value-type="YYYY-MM-DD"
                        format="DD.MM.YYYY"
                        @blur="
                          organization.company_ceo_date == ' '
                            ? (organization.company_ceo_date = '')
                            : (organization.company_ceo_date =
                                organization.company_ceo_date)
                        "
                        inputClass="form-control"
                        :disabled="is_field_readonly"
                        v-model="organization.company_ceo_date"
                        :placeholder="$t('message.account.company_ceo_date')"
                        :inputAttr="{ id: 'company_ceo_date' }"
                      />
                      <!-- <b-form-datepicker :locale="locale" v-model="organization.company_ceo_date" :placeholder="$t('message.account.company_ceo_date')" size="sm" no-flip :hide-header="true" :show-button="false" class="py-0" :show-decade-nav="false" id="company_ceo_date" v-else></b-form-datepicker> -->
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_filials">{{
                        $t("message.account.company_filials")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_filials
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="company_filials"
                        v-model="organization.company_filials"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="company_website">{{
                        $t("message.account.company_website")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.company_website
                      }}</span>
                      <input
                        type="text"
                        class="form-control"
                        id="company_website"
                        v-model="organization.company_website"
                        v-else
                      />
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-4">
                      <label for="country">{{
                        $t("message.account.country")
                      }}</label>
                    </div>
                    <div class="col-md-8">
                      <span v-if="!edit_company">{{
                        organization.country.display_text
                      }}</span>
                      <!-- <v-select id="residency" :options="countries" label="display_text" :class="['form-control', typeof organization.country !== 'undefined' && organization.country!==''?'vs--selected':'']" @search=fetchCountries v-model="organization.country" v-else></v-select> -->
                      <v-select-popup
                        v-else
                        type="country"
                        v-model="organization.country"
                        :placeholder="$t('message.account.country')"
                      />
                    </div>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_broker") }}</span
                      ><br /><br />
                      <input
                        type="checkbox"
                        v-model="organization.org_is_broker"
                        :disabled="!edit_company"
                      />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_carrier") }}</span
                      ><br /><br />
                      <input
                        type="checkbox"
                        v-model="organization.org_is_carrier"
                        :disabled="!edit_company"
                      />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="togglebutton mt-md-3 form-label-group">
                    <label class="control-label-sm">
                      <span>{{ $t("message.account.org_is_bank") }}</span
                      ><br /><br />
                      <input
                        type="checkbox"
                        v-model="organization.org_is_bank"
                        :disabled="!edit_company"
                      />
                      <span class="toggle"></span>
                      <span class="female">{{ $t("message.yes") }}</span>
                      <span class="male">{{ $t("message.no") }}</span>
                    </label>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label for="country">{{
                        $t("message.account.kpved")
                      }}</label>
                    </div>
                    <div class="col-md-12 mb-3" v-if="!edit_company">
                      <span
                        class="badge badge-info"
                        v-for="label in organization_kpveds_tags"
                        >{{ label }}</span
                      >
                    </div>
                    <div
                      class="col-md-12"
                      v-if="edit_company"
                      style="margin-top: -20px"
                    >
                      <claster-selector
                        v-model="organization.organization_kpveds"
                        id="kpved"
                        :label="$t('message.contracts.good_selector')"
                        :label2="$t('message.contracts.good_selector_c1')"
                        :label3="$t('message.contracts.good_selector_c2')"
                        :label4="$t('message.contracts.good_selector_c3')"
                        :label5="$t('message.contracts.good_selector_c4')"
                        :label6="$t('message.contracts.good_selector_c5')"
                        type="kpved"
                        :required="true"
                      ></claster-selector>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <a
                        v-show="!empty(socials.skype)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="'skype:' + socials.skype"
                        ><i class="text-info fab fa-skype fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials.linkedin)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials.linkedin"
                        ><i class="text-info fab fa-linkedin fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials.fb)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials.fb"
                        ><i class="text-info fab fa-facebook fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials.instagram)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials.instagram"
                        ><i class="text-info fab fa-instagram fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials.vk)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="socials.vk"
                        ><i class="text-info fab fa-vk fa-2x"></i
                      ></a>
                      <a
                        v-show="!empty(socials.wechat)"
                        class="text-info mr-2"
                        target="_blank"
                        rel="noopener noreferrer"
                        :href="'weixin://dl/chat?' + socials.wechat"
                        ><i class="text-info fab fa-weixin fa-2x"></i
                      ></a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <div
                        id="company_map"
                        :class="[
                          'mt-3',
                          'rounded',
                          loading_map_company ? 'loading-map' : '',
                        ]"
                        style="height: 300px"
                      ></div>
                    </div>
                  </div>
                  <div class="row my-2" v-if="edit_company">
                    <div class="col-12">
                      <button class="btn btn-success" @click="saveCompany()">
                        {{ $t("message.save") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!--<h1>{{organization.org_name}}</h1>
							<dl>
								<dt>{{$t('message.account.bin')}}:</dt>
								<dd>{{organization.org_code}}</dd>

								<dt>{{$t('message.account.company-country')}}:</dt>
								<dd>{{residency.display_text}}</dd>
							</dl>
							<hr class="my-4">
							<h2>{{person.given_name}} {{person.last_name}}</h2>
							<dl>
								<dt>{{$t('message.account.iin')}}:</dt>
								<dd>{{person.person_code}}</dd>

								<dt>{{$t('message.account.dob')}}:</dt>
								<dd>{{momentum(person.date_of_birth)}}</dd>

								<dt>{{$t('message.account.gender')}}:</dt>
								<dd>{{gender(person.gender)}}</dd>
							</dl>

							<router-link :to="{name: 'account-edit'}" class="btn btn-success">{{$t('message.edit')}}</router-link>
							-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import ClasterSelector from "./../fields/claster-selector.vue";
export default {
  components: {
    ClasterSelector,
  },
  data() {
    return {
      show: 0,
      edit_person: false,
      edit_company: false,
      edit_bank: false,
      edit_founder: false,
      loading_map: false,
      loading_map_company: false,

      wrong_old_password: false,
      insecure_new_password: false,
      short_new_password: false,

      countries: [],
      okeds: [],
      statuses: [],
      currencies: [],
      org_types: [],
      autocompleteitems: [],
      organization_kpveds: "",
      organization_kpveds_tags: [],
      map: null,
      map_company: null,
      map_point: null,
      map_point_company: null,
      timeout: null,

      old_password: "",
      new_password: "",
      confirm_password: "",

      subj_bank_accounts: [],
      organizations_founders: [],

      organization: {},
      person: {},
      residency: {},

      socials: {
        skype: "",
        linkedin: "",
        fb: "",
        instagram: "",
        vk: "",
        wechat: "",
      },
      socials_person: {
        skype: "",
        linkedin: "",
        fb: "",
        instagram: "",
        vk: "",
        wechat: "",
      },

      address_1: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },
      address_2: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },
      address_3: {
        post_addr_index: "",
        post_addr_country: { value: "" },
        post_addr_region: "",
        post_addr_district: "",
        post_addr_town: "",
        post_addr_city: "",
        post_addr_streethouse: "",
        post_addr_house: "",
        post_addr_room: "",
        post_addr_comm_number: "",
      },

      new_bank: {
        subj_bank_name: "",
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      },
      new_founder: {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      },
    };
  },
  mounted() {
    // this.fetchOrgTypes('')
    // this.fetchCountries('')
    // this.fetchCurrency('')
    // this.fetchOkeds('')
    // this.fetchStatuses('')

    this.load();

    this.$root.$on("change-avatar", (data) => {
      this.person.avatar = data.avatar;
    });
    this.$root.$on("change-logo", (data) => {
      this.organization.logo = data.logo;
    });

    window.addEventListener("resize", () => {
      setTimeout(() => {
        this.showMap();
        this.showMapCompany();
      }, 1000);
    });
    this.$root.$on("screen-resize", (is_expand) => {
      setTimeout(() => {
        this.showMap();
        this.showMapCompany();
      }, 1000);
    });
    //if we open the page to view personal profile
    if (this.$route.name == "user-profile-personal") {
      this.show = 1;
    }
    //if we open the page to view company profile
    if (this.$route.name == "user-profile-company") {
      this.show = 2;
    }
  },
  computed: {
    url() {
      return window.base + "/picture/avatar_upload";
    },
    url_company() {
      return window.base + "/picture/logo_upload";
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
        case "ru":
          locale = "ru-RU";
          break;
      }
      return locale;
    },
  },
  methods: {
    cloneAddress(direction) {
      if (direction == "post") {
        this.address_2 = { ...this.address_1 };
      }
      if (direction == "fact") {
        this.address_3 = { ...this.address_1 };
      }
    },
    processOrganizationKpveds() {
      var t = this.organization.organization_kpveds;
      axios
        .get(
          window.base +
            "/classification?type=kpved&level=names&query=" +
            t +
            "&qty=10" +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.organization_kpveds_tags = _.map(response.data, (i) => {
            return i.display_text;
          });
        });
    },
    empty(string) {
      return _.isEmpty(string);
    },
    addFounder() {
      this.organizations_founders.push({
        org_founders_person_name: this.new_founder.org_founders_person_name,
        org_founders_company: this.new_founder.org_founders_company,
        org_founders_country: this.new_founder.org_founders_country,
        org_founders_share: this.new_founder.org_founders_share,
      });
      this.new_founder = {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      };
    },
    saveFounder() {
      this.edit_founder = false;
      this.new_founder = {
        org_founders_person_name: "",
        org_founders_company: "",
        org_founders_country: { value: "", display_text: "" },
        org_founders_share: "",
      };
    },
    removeFounder(index) {
      this.organizations_founders.splice(index, 1);
    },
    editFounder(index) {
      this.new_founder = this.organizations_founders[index];
      this.edit_founder = true;
    },
    addBank() {
      this.subj_bank_accounts.push({
        subj_bank_name: this.new_bank.subj_bank_name,
        subj_bank_acc_number: this.new_bank.subj_bank_acc_number,
        subj_bank_acc_curr: this.new_bank.subj_bank_acc_curr,
        subj_bank_acc_status: this.new_bank.subj_bank_acc_status,
      });
      this.new_bank = {
        subj_bank_name: "",
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      };
    },
    saveBank() {
      this.edit_bank = false;
      this.new_bank = {
        subj_bank_name: "",
        subj_bank_acc_number: "",
        subj_bank_acc_curr: { value: "", display_text: "" },
        subj_bank_acc_status: "",
      };
    },
    removeBank(index) {
      this.subj_bank_accounts.splice(index, 1);
    },
    editBank(index) {
      this.new_bank = this.subj_bank_accounts[index];
      this.edit_bank = true;
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········")
              if (
                type == "oked" ||
                type == "declaration_kind" ||
                type == "goods_transfer_feature"
              ) {
                item.display_text = item.value + " - " + item.display_text;
                this.$data[var_name].push(item);
              } else this.$data[var_name].push(item);
          });
        });
    },
    fetchOrgTypes(search, loading) {
      this.getLibrary("org_type", search, 1000000);
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 1000000);
    },
    fetchCurrency(search, loading) {
      this.getLibrary("currency", search, 1000000);
    },
    fetchOkeds(search, loading) {
      this.getLibrary("oked", search, 1000000);
    },
    fetchStatuses(search, loading) {
      this.getLibrary("status", search, 1000000);
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        this.$set(this.organization, field, { value: "", display_text: "" });
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value.trim() == value.trim()) {
                item.display_text = item.value + " - " + item.display_text;
                this.$set(this.organization, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.ap_main, field, item);
        });
      }
    },
    findLibValuePerson(lib, value, field) {
      if (typeof lib == "string") {
        this.$set(this.person, field, { value: "", display_text: "" });
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (item.value.trim() == value.trim()) {
                item.display_text = item.value + " - " + item.display_text;
                this.$set(this.person, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value == value) this.$set(this.ap_main, field, item);
        });
      }
    },

    load() {
      axios
        .get(
          window.base + "/document/getFirmbyBin?bin=" + this.$route.params.id,
        )
        .then((response) => {
          this.organization = response.data.organizations;
          this.subj_bank_accounts = response.data.banks;
          this.socials_person = response.data.person_socials;
          this.socials = response.data.socials;
          if (
            typeof this.organization.logo === "undefined" ||
            this.organization.logo == ""
          )
            this.organization.logo = "https://via.placeholder.com/450?text=+";
          this.person = response.data.persons;
          if (
            typeof this.person.avatar === "undefined" ||
            this.person.avatar == ""
          )
            this.person.avatar = "https://via.placeholder.com/450?text=+";
          this.person.date_of_birth = this.momentum(this.person.date_of_birth);
          this.person.gender = parseInt(this.person.gender);
          this.residency = response.data.org_residency;

          this.organization.org_reg_date = this.momentum(
            this.organization.org_reg_date,
          );
          this.organization.org_reregdate = this.momentum(
            this.organization.org_reregdate,
          );
          this.organization.company_ceo_date = this.momentum(
            this.organization.company_ceo_date,
          );

          this.findLibValue(
            "oked",
            response.data.organizations.org_oked.trim(),
            "org_oked",
          );
          this.findLibValue(
            "country",
            response.data.organizations.country.trim(),
            "country",
          );
          this.findLibValuePerson(
            "country",
            response.data.persons.country.trim(),
            "country",
          );
          if (response.data.organizations.company_status !== null)
            this.findLibValue(
              "status",
              typeof response.data.organizations.company_status !== "undefined"
                ? response.data.organizations.company_status
                : "1",
              "company_status",
            );
          else
            this.organization.company_status = { value: "", display_text: "" };

          this.findLibValue(
            "org_type",
            response.data.organizations.org_type.trim(),
            "org_type",
          );

          this.processOrganizationKpveds();

          response.data.addresses.forEach((address) => {
            if (address.subj_post_addr_type == 1) {
              this.address_1 = address;
            }
            if (address.subj_post_addr_type == 2) {
              this.address_2 = address;
            }
            if (address.subj_post_addr_type == 3) {
              this.address_3 = address;
            }
          });
          if (typeof this.address_1 == "undefined")
            this.address_1 = {
              post_addr_index: "",
              post_addr_country: { value: "", display_text: "" },
              post_addr_region: "",
              post_addr_district: "",
              post_addr_town: "",
              post_addr_city: "",
              post_addr_streethouse: "",
              post_addr_house: "",
              post_addr_room: "",
              post_addr_comm_number: "",
            };
          else
            this.address_1.post_addr_country =
              this.countries[
                this.countries.findIndex(
                  (i) => i.value == this.address_1.post_addr_country.trim(),
                )
              ];
          if (typeof this.address_2 == "undefined")
            this.address_2 = {
              post_addr_index: "",
              post_addr_country: { value: "", display_text: "" },
              post_addr_region: "",
              post_addr_district: "",
              post_addr_town: "",
              post_addr_city: "",
              post_addr_streethouse: "",
              post_addr_house: "",
              post_addr_room: "",
              post_addr_comm_number: "",
            };
          else
            this.address_2.post_addr_country =
              this.countries[
                this.countries.findIndex(
                  (i) => i.value == this.address_2.post_addr_country.trim(),
                )
              ];
          if (typeof this.address_3 == "undefined")
            this.address_3 = {
              post_addr_index: "",
              post_addr_country: { value: "", display_text: "" },
              post_addr_region: "",
              post_addr_district: "",
              post_addr_town: "",
              post_addr_city: "",
              post_addr_streethouse: "",
              post_addr_house: "",
              post_addr_room: "",
              post_addr_comm_number: "",
            };
          else
            this.address_3.post_addr_country =
              this.countries[
                this.countries.findIndex(
                  (i) => i.value == this.address_3.post_addr_country.trim(),
                )
              ];
          if (typeof this.address_1.post_addr_country == "undefined")
            this.address_1.post_addr_country = { value: "", display_text: "" };
          if (typeof this.address_2.post_addr_country == "undefined")
            this.address_2.post_addr_country = { value: "", display_text: "" };
          if (typeof this.address_3.post_addr_country == "undefined")
            this.address_3.post_addr_country = { value: "", display_text: "" };
        });
    },
    momentum(dt) {
      if (_.isEmpty(dt)) return "";
      var m = moment(dt).format("YYYY-MM-DD");
      return m;
    },
    gender(gender) {
      return gender == 0
        ? this.$t("message.account.male")
        : this.$t("message.account.female");
    },
    show_user() {
      this.show = 1;
      setTimeout(() => {
        this.showMap();
      }, 2000);
    },
    show_company() {
      this.show = 2;
      setTimeout(() => {
        this.showMapCompany();
      }, 2000);
    },
    editPerson() {
      if (this.edit_person == false) this.edit_person = true;
      else this.savePerson();
    },
    editCompany() {
      if (this.edit_company == false) this.edit_company = true;
      else this.saveCompany();
    },
    savePerson() {
      this.edit_person = false;
      var formdata = new FormData();
      for (var i in this.person) {
        if (i !== "country" && i !== "gender")
          formdata.append(i, this.person[i]);
      }
      formdata.append("gender", this.person.gender);
      formdata.append("country", this.person.country.value);
      axios.post(window.base + "/account/save", formdata);
    },
    saveCompany() {
      this.edit_company = false;
      var formdata = new FormData();
      for (var i in this.organization) {
        if (
          i == "org_is_bank" ||
          i == "org_is_broker" ||
          i == "org_is_carrier"
        ) {
          if (this.organization[i] === true) this.organization[i] = 1;
          if (this.organization[i] === false) this.organization[i] = 0;
        }
        if (i == "org_oked")
          formdata.append(
            i,
            typeof this.organization[i].value !== "undefined"
              ? this.organization[i].value
              : "",
          );
        else if (i == "company_status")
          formdata.append(
            i,
            typeof this.organization[i].value !== "undefined"
              ? this.organization[i].value
              : "",
          );
        else if (i == "country")
          formdata.append(
            i,
            typeof this.organization[i].value !== "undefined"
              ? this.organization[i].value
              : "",
          );
        else if (i == "org_type")
          formdata.append(
            i,
            typeof this.organization[i].value !== "undefined"
              ? this.organization[i].value
              : "",
          );
        else formdata.append(i, this.organization[i]);
      }
      // formdata.append('residency', this.residency.value)
      axios.post(window.base + "/account/save_organization", formdata);
    },
    saveSocials() {
      var formdata = new FormData();
      for (var i in this.socials) {
        formdata.append(i, this.socials[i]);
      }
      axios.post(window.base + "/account/save_socials", formdata);
      this.$bvModal.hide("modal-socials");
    },
    saveSocialsPerson() {
      var formdata = new FormData();
      for (var i in this.socials_person) {
        formdata.append(i, this.socials_person[i]);
      }
      axios.post(window.base + "/account/save_socials_personal", formdata);
      this.$bvModal.hide("modal-socials-persons");
    },
    savePassword() {
      if (
        !_.isEmpty(this.old_password) &&
        !_.isEmpty(this.new_password) &&
        !_.isEmpty(this.confirm_password)
      ) {
        if (this.new_password != this.confirm_password) {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.account.passwords_not_equal"),
            timeout: 5000,
          }).show();
        } else {
          var formdata = new FormData();
          formdata.append("old_password", this.old_password);
          formdata.append("new_password", this.new_password);
          axios
            .post(window.base + "/account/savePassword", formdata)
            .then((response) => {
              if (response.data.status == "ok") {
                this.$bvModal.hide("modal-change-password");
                this.wrong_old_password = false;
              } else {
                if (response.data.status == "Incorrect password.") {
                  this.wrong_old_password = true;
                } else {
                  if (
                    response.data.status ==
                    "Пароль должен иметь длинну 8 символов"
                  ) {
                    this.short_new_password = true;
                  } else {
                    this.insecure_new_password = true;
                  }
                }
              }
            });
        }
      } else {
        new Noty({
          theme: "light",
          type: "error",
          text: this.$t("message.account.fill_all_fields"),
          timeout: 5000,
        }).show();
      }
    },
    saveBanks() {
      var formdata = new FormData();
      this.subj_bank_accounts.forEach((bank, i) => {
        formdata.append("subj_bank_name[" + i + "]", bank.subj_bank_name);
        formdata.append(
          "subj_bank_acc_number[" + i + "]",
          bank.subj_bank_acc_number,
        );
        formdata.append(
          "subj_bank_acc_curr[" + i + "]",
          bank.subj_bank_acc_curr.value,
        );
        formdata.append(
          "subj_bank_acc_status[" + i + "]",
          bank.subj_bank_acc_status,
        );
      });
      axios.post(window.base + "/account/save_banks", formdata);
      this.$bvModal.hide("modal-account");
    },
    saveFounders() {
      var formdata = new FormData();
      this.organizations_founders.forEach((founder, i) => {
        formdata.append(
          "org_founders_person_name[" + i + "]",
          founder.org_founders_person_name,
        );
        formdata.append(
          "org_founders_company[" + i + "]",
          founder.org_founders_company,
        );
        formdata.append(
          "org_founders_country[" + i + "]",
          founder.org_founders_country.value,
        );
        formdata.append(
          "org_founders_share[" + i + "]",
          founder.org_founders_share,
        );
      });

      axios.post(window.base + "/account/save_founders", formdata);
      this.$bvModal.hide("modal-founders");
    },
    saveAddresses() {
      var formdata = new FormData();
      formdata.append("subj_post_addr_type[0]", 1);
      formdata.append("post_addr_index[0]", this.address_1.post_addr_index);
      formdata.append(
        "post_addr_country[0]",
        this.address_1.post_addr_country.value,
      );
      formdata.append("post_addr_region[0]", this.address_1.post_addr_region);
      formdata.append(
        "post_addr_district[0]",
        this.address_1.post_addr_district,
      );
      formdata.append("post_addr_town[0]", this.address_1.post_addr_town);
      formdata.append("post_addr_city[0]", this.address_1.post_addr_city);
      formdata.append(
        "post_addr_streethouse[0]",
        this.address_1.post_addr_streethouse,
      );
      formdata.append("post_addr_house[0]", this.address_1.post_addr_house);
      formdata.append("post_addr_room[0]", this.address_1.post_addr_room);
      formdata.append(
        "post_addr_comm_number[0]",
        this.address_1.post_addr_comm_number,
      );

      formdata.append("subj_post_addr_type[1]", 3);
      formdata.append("post_addr_index[1]", this.address_3.post_addr_index);
      formdata.append(
        "post_addr_country[1]",
        this.address_3.post_addr_country.value,
      );
      formdata.append("post_addr_region[1]", this.address_3.post_addr_region);
      formdata.append(
        "post_addr_district[1]",
        this.address_3.post_addr_district,
      );
      formdata.append("post_addr_town[1]", this.address_3.post_addr_town);
      formdata.append("post_addr_city[1]", this.address_3.post_addr_city);
      formdata.append(
        "post_addr_streethouse[1]",
        this.address_3.post_addr_streethouse,
      );
      formdata.append("post_addr_house[1]", this.address_3.post_addr_house);
      formdata.append("post_addr_room[1]", this.address_3.post_addr_room);
      formdata.append(
        "post_addr_comm_number[1]",
        this.address_3.post_addr_comm_number,
      );

      formdata.append("subj_post_addr_type[2]", 2);
      formdata.append("post_addr_index[2]", this.address_2.post_addr_index);
      formdata.append(
        "post_addr_country[2]",
        this.address_2.post_addr_country.value,
      );
      formdata.append("post_addr_region[2]", this.address_2.post_addr_region);
      formdata.append(
        "post_addr_district[2]",
        this.address_2.post_addr_district,
      );
      formdata.append("post_addr_town[2]", this.address_2.post_addr_town);
      formdata.append("post_addr_city[2]", this.address_2.post_addr_city);
      formdata.append(
        "post_addr_streethouse[2]",
        this.address_2.post_addr_streethouse,
      );
      formdata.append("post_addr_house[2]", this.address_2.post_addr_house);
      formdata.append("post_addr_room[2]", this.address_2.post_addr_room);
      formdata.append(
        "post_addr_comm_number[2]",
        this.address_2.post_addr_comm_number,
      );

      axios.post(window.base + "/account/save_addresses", formdata);

      this.$bvModal.hide("modal-addresses");
    },
    showMap() {
      if (
        document.querySelectorAll("#person_map").length > 0 &&
        this.show == 1
      ) {
        this.loading_map = true;
        if (typeof ymaps !== "undefined") {
          var address = this.person.post_address;
          if (_.isEmpty(address)) address = "Казахстан, Нур-Султан";
          axios
            .get(
              "https://geocode-maps.yandex.ru/1.x?geocode=" +
                address +
                "&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4&format=json",
            )
            .then((response) => {
              if (
                typeof response.data.response.GeoObjectCollection
                  .featureMember !== "undefined" &&
                response.data.response.GeoObjectCollection.featureMember
                  .length > 0
              ) {
                var latlng =
                  response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(
                    " ",
                  );
                document.querySelector("#person_map").innerHTML = "";
                this.map = new ymaps.Map(
                  "person_map",
                  {
                    center: [latlng[1], latlng[0]],
                    zoom: 17,
                  },
                  {
                    searchControlProvider: "yandex#search",
                  },
                );
                this.map_point = new ymaps.GeoObject(
                  {
                    // Описание геометрии.
                    geometry: {
                      type: "Point",
                      coordinates: [latlng[1], latlng[0]],
                    },
                  },
                  {
                    // Опции.
                    // Иконка метки будет растягиваться под размер ее содержимого.
                    preset: "islands#blackStretchyIcon",
                    // Метку можно перемещать.
                    // draggable: true
                  },
                );
                this.map.geoObjects.add(this.map_point);
                this.loading_map = false;
              }
            });
        }
      }
    },
    showMapCompany() {
      if (
        document.querySelectorAll("#company_map").length > 0 &&
        this.show == 2
      ) {
        this.loading_map_company = true;
        if (typeof ymaps !== "undefined") {
          var address =
            this.address_2.post_addr_country.display_text +
            " " +
            this.address_2.post_addr_town +
            " " +
            this.address_2.post_addr_streethouse +
            " " +
            this.address_2.post_addr_house;
          if (_.isEmpty(address.trim())) address = "Казахстан, Нур-Султан";
          axios
            .get(
              "https://geocode-maps.yandex.ru/1.x?geocode=" +
                address +
                "&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4&format=json",
            )
            .then((response) => {
              if (
                typeof response.data.response.GeoObjectCollection
                  .featureMember !== "undefined" &&
                response.data.response.GeoObjectCollection.featureMember
                  .length > 0
              ) {
                var latlng =
                  response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(
                    " ",
                  );
                document.querySelector("#company_map").innerHTML = "";
                this.map_company = new ymaps.Map(
                  "company_map",
                  {
                    center: [latlng[1], latlng[0]],
                    zoom: 17,
                  },
                  {
                    searchControlProvider: "yandex#search",
                  },
                );
                this.map_point_company = new ymaps.GeoObject(
                  {
                    // Описание геометрии.
                    geometry: {
                      type: "Point",
                      coordinates: [latlng[1], latlng[0]],
                    },
                  },
                  {
                    // Опции.
                    // Иконка метки будет растягиваться под размер ее содержимого.
                    preset: "islands#blackStretchyIcon",
                    // Метку можно перемещать.
                    // draggable: true
                  },
                );
                this.map_company.geoObjects.add(this.map_point_company);
                this.loading_map_company = false;
              }
            });
        }
      }
    },
  },
  watch: {
    edit_company() {
      this.processOrganizationKpveds();
    },
    person: {
      deep: true,
      handler() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          setTimeout(() => {
            this.showMap();
          }, 2000);
        }, 2000);
      },
    },
  },
};
</script>
<style type="text/css">
.loading-map {
  background-image: url(data:image/gif;base64,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);
  background-repeat: no-repeat;
  background-position: center;
}

.vs--single .vs__selected {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
#person_map,
#company_map {
  overflow-x: hidden;
}
</style>
